import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

class StartupErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("[BOOT] React fatal error boundary", error);
    const key = "study_partner_recovery_done";
    if (sessionStorage.getItem(key) === "1") return;
    sessionStorage.setItem(key, "1");
    try {
      localStorage.clear();
      sessionStorage.clear();
      if ("caches" in window) {
        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
      }
    } finally {
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

function runStartupRecovery(reason, detail) {
  console.error("[BOOT] startup recovery", reason, detail);
  const key = "study_partner_recovery_done";
  if (sessionStorage.getItem(key) === "1") return;
  sessionStorage.setItem(key, "1");
  try {
    localStorage.clear();
    if ("caches" in window) {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
    }
  } finally {
    window.location.reload();
  }
}

window.addEventListener("error", (event) => {
  const msg = String(event?.message || "");
  if (msg.includes("Loading chunk") || msg.includes("ChunkLoadError") || msg.includes("Unexpected token")) {
    runStartupRecovery("window.error", msg);
  }
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = String(event?.reason?.message || event?.reason || "");
  if (reason.includes("Loading chunk") || reason.includes("ChunkLoadError") || reason.includes("Failed to fetch")) {
    runStartupRecovery("unhandledrejection", reason);
  }
});

const currentVersion = window.__APP_BUILD_VERSION__ || "1.1.0";
const storedVersion = localStorage.getItem("study_partner_build");
if (storedVersion !== currentVersion) {
  localStorage.setItem("study_partner_build", currentVersion);
  // Clear stale auth/cache markers once per new release.
  sessionStorage.removeItem("study_partner_recovery_done");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
const appTree = (
  <StartupErrorBoundary>
    <App />
  </StartupErrorBoundary>
);
if (process.env.NODE_ENV === "development") {
  root.render(<React.StrictMode>{appTree}</React.StrictMode>);
} else {
  root.render(appTree);
}

// Service Worker rimosso: deregistrazione immediata (non attendere "load").
if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
  if ("caches" in window) {
    caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key))));
  }
}
